import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

function BagError() {
  const t = useTranslations('bag');

  return (
    <div className={styles.container}>
      <Heading variant="md" as="h1" className={styles.title}>
        {t('Bag.Error.Title')}
      </Heading>
      <Heading variant="sm" as="p">
        {t('Bag.Error.Subtitle')}
      </Heading>
    </div>
  );
}

export { BagError };
